import React, { useRef, useState, useEffect } from 'react'
import Modal from '../../UI/Modal/Modal'
import './UserMenu.css'
import FetchData from '../../../shared/fetchData'
import { useHistory } from 'react-router-dom'

const UserMenu = (props) => {

    const [token, setToken] = useState(window.localStorage.getItem("token"))
    const [balance, setBalance] = useState()
    const [content, setContent] = useState()
    const [loading, setLoading] = useState(false)
    const childRef = useRef()

    let history = useHistory();


    const getOngoingOrders = (event) => {
        history.push('/ONGOING-ORDERS');
        props.closeSideBar(event)
    }

    const getFinishedOrders = (event) => {
        history.push('/FINISHED-ORDERS');
        props.closeSideBar(event)
    }

    const getFavouriteOrders = (event) => {
        history.push('/FAVOURITE-ORDERS');
        props.closeSideBar(event)
    }
    const getVoiceOrders = (event) => {
        history.push('/VOICE-ORDERS');
        props.closeSideBar(event)
    }
    const getProfileInfo = (event) => {
        history.push('/PROFILE')
        props.closeSideBar(event)
    }
    const getFavouriteParcels = (event) => {
        history.push('/FAVOURITE-PARCELS')
        props.closeSideBar(event)
    }
    const getFavouriteContacts = (event) => {
        history.push('/FAVOURITE-CONTACTS')
        props.closeSideBar(event)
    }

    const closeModal = (event) => {
        childRef.current.closeModal()
    }

    const afterCloseModal = (event) => {
    }
    const menu = token != '' && token != null ? <div>

        <div className="row">

            <div className="UserMenuContent" onClick={getProfileInfo}>
                اطلاعات حساب
    </div>
        </div>
        <div className="row" onClick={getOngoingOrders}>
            <div className="UserMenuContent">
                سفارشات جاری
</div>
        </div>
        <div className="row" onClick={getFinishedOrders}>
            <div className="UserMenuContent">
                سفارشات تحویل شده
</div>
        </div>
        <div className="row" onClick={getFavouriteOrders}>
            <div className="UserMenuContent">
                سفارشات منتخب
</div>
        </div>
        <div className="row" onClick={getVoiceOrders}>
            <div className="UserMenuContent">
                سفارشات صوتی
</div>
        </div>
        <div className="row" onClick={getFavouriteParcels}>
            <div className="UserMenuContent">
                مرسوله های منتخب
</div>
        </div>
        <div className="row" onClick={getFavouriteContacts}>
            <div className="UserMenuContent">
                آدرس های منتخب
</div>
        </div>
        < Modal
            content={content}
            ref={childRef}
            closePermission={true}
            closeModal={(event) => afterCloseModal(event)}
        />
    </div> : ''
    return (
        menu
    )
}

export default UserMenu